import { Phone, Mail } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const ContactLink = ({ href, icon: Icon, label, value, testId }) => (
  <a data-testid={testId} href={href} className="group flex items-center gap-4">
    <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gold/15 text-gold transition-transform group-hover:scale-110">
      <Icon size={18} />
    </span>
    <span>
      <span className="block font-mono text-[10px] uppercase tracking-[0.2em] text-white/50">{label}</span>
      <span className="block font-display text-xl font-bold text-white transition-colors group-hover:text-gold">{value}</span>
    </span>
  </a>
);

export const ContactInfo = () => (
  <div className="p-8 sm:p-12 lg:p-16">
    <Reveal>
      <Eyebrow light>Contact</Eyebrow>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-5 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">Parlons de votre projet.</h2>
    </Reveal>
    <Reveal delay={0.16}>
      <p className="mt-4 max-w-md text-base leading-relaxed text-white/70">
        Décrivez-nous votre activité, nous vous répondons avec un avis honnête et un devis gratuit. Pas d'engagement, pas de jargon.
      </p>
    </Reveal>
    <Reveal delay={0.24}>
      <div className="mt-10 space-y-5">
        <ContactLink testId="contact-phone-link" href="tel:+33784678802" icon={Phone} label="Téléphone" value="07 84 67 88 02" />
        <ContactLink testId="contact-email-link" href="mailto:site.com@outlook.fr" icon={Mail} label="Email" value="site.com@outlook.fr" />
      </div>
    </Reveal>
  </div>
);
